export default __webpack_public_path__ + "static/media/user.4784a099.svg";